__turbopack_context__.v({
  "actionButton": "nPXgoa_actionButton",
  "calEmbed": "nPXgoa_calEmbed",
  "donnyBookingEmbed": "nPXgoa_donnyBookingEmbed",
  "externalLink": "nPXgoa_externalLink",
  "fallback": "nPXgoa_fallback",
  "fallbackActions": "nPXgoa_fallbackActions",
  "frame": "nPXgoa_frame",
  "frameWrap": "nPXgoa_frameWrap",
  "header": "nPXgoa_header",
  "loadingProgress": "nPXgoa_loadingProgress",
  "subtitle": "nPXgoa_subtitle",
  "title": "nPXgoa_title",
});
